import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { JarvisOrb } from "@/components/JarvisOrb";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, setDenied } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate("/"); return; }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        await api.post("/bootstrap");
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { state: { user: res.data } });
      } catch (e) {
        if (e?.response?.status === 403) { // account not on the owner allowlist
          const d = e.response.data?.detail;
          setDenied({ message: typeof d === "string" ? d : undefined });
        }
        window.history.replaceState({}, document.title, "/");
        navigate("/");
      }
    })();
  }, [navigate, setUser, setDenied]);

  return (
    <div className="min-h-screen hud-bg flex items-center justify-center">
      <JarvisOrb state="thinking" size={200} />
    </div>
  );
}
